import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto text-center py-24 px-6 fade-in-up">
      <div className="w-16 h-16 border-2 border-[#B91C1C] rounded-full grid place-items-center mx-auto mb-6"><XCircle className="w-8 h-8 text-[#B91C1C]" /></div>
      <h1 className="font-serif text-3xl font-bold text-[#0A192F] mb-3">Payment cancelled.</h1>
      <p className="text-slate-600 mb-6">You can retry any time from the Invoices page.</p>
      <Link to="/portal/invoices" className="btn-navy px-6 py-3 text-[12px] uppercase tracking-widest inline-flex" data-testid="retry-invoices">Return to Invoices</Link>
    </div>
  );
}
